import React from 'react';
import { useTranslation } from 'react-i18next';

export const MakeWishTip = () => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center items-center text-center text-sm font-semibold text-[var(--muted)] max-w-[80%] mx-auto flex-wrap py-4">
      <span>{t('leader_page.note_text')} </span>
      <a
        href={`${window.location.origin}/make-a-wish`}
        target="_blank"
        rel="noopener noreferrer"
        className="underline text-[var(--brand)] ml-1 hover:text-[var(--brand-dark)]"
      >
        {t('leader_page.make_a_wish')}
      </a>
    </div>
  );
};
